import React , {useState} from 'react'
import "./CarouselSlide.css";

import Slider from "react-slick";

const NextArrow = (props)=> {
    const {className, style, onClick} = props;
    return (
        <div aria-label="Next" className={className + " fas fa-angle-right"} style={style} onClick={onClick} />
    )
}
const PrevArrow = (props)=> {
    const {className, style, onClick} = props;
    return (
        <div aria-label="Prev" className={className + " fas fa-angle-left"} style={style} onClick={onClick} />
    )
};

class CarouselSlide extends React.Component {
        constructor(props) {
            super(props);            
            this.state = {
                tablet: window.innerWidth < 769,
                mobile: window.innerWidth < 520,
                needRendition: props.carouselRendition>4,
                autoPlayButton: true
                
            };
            window.addEventListener("resize", this.resize.bind(this));
        }
        resize(){
            let tablet= window.innerWidth < 769;
            let mobile= window.innerWidth < 520;
            if(mobile !== this.state.mobile || tablet !== this.state.tablet){
                this.setState({mobile:mobile,
                tablet:tablet})
            }
        }
        playPauseButtonClicked = () => {
            this.setState({autoPlayButton: !this.state.autoPlayButton});
        }
        render() {
            const settings ={
                dots: true,
                infinite: true,
                speed:700,
                slidesToShow: 1,
                rows: 1,
                slidesPerRow: 1,
                slidesToScroll:1,
                centerMode:true,
                autoplay: this.state.autoPlayButton,
                autoplaySpeed: 5000,
                swipeToSlide:true,
                nextArrow: <NextArrow/>,
                prevArrow: <PrevArrow/>,
                adaptiveHeight: false,
                centerPadding:  0
            }
    return (
        <React.Fragment>
            <div className="carouselSliderContainer">
                <div id="mod-carousel" className="carousel " data-ride="carousel">
                    <div className="carousel-inner">
                        <Slider {...settings}>
                            {this.props.items.map((item,index) => (
                                <div className={"slide carousel-item "} key={"modCarouselItem"+index}>
                                {this.state.needRendition?
                                            <img className="d-block w-100" src={item.FileRef + "?RenditionID=" + this.props.carouselRendition } alt={item.Title}></img>
                                            :
                                            <img className="d-block w-100" src={item.FileRef} alt={item.Title}></img>
                                        }
                                </div>
                            ))}
                        </Slider>
                    </div>
                    {(this.props.moreLink) ?
                    <a className="ExhibitionsButtonLink" href={this.props.moreLink} title="תצוגות"> תצוגות <i className="fas fa-angle-left"></i>
                    </a>
                    : null}
                    <div className="autoPlayAccessibilityHPSlider" onClick={this.playPauseButtonClicked}>
                        <i className={this.state.autoPlayButton ? "hidePlayButton" : "far fa-play-circle"} alt="הפעל"></i>

                        <i className={this.state.autoPlayButton ? "far fa-pause-circle" : "hidePlayButton"} alt="עצור"></i>
                </div>
                </div>
            </div>
            <div className="linear-gradient-text">
                <div className="innerText">
                    <h3 dangerouslySetInnerHTML={{__html: this.props.moreTitle}} />
                    <h4>{this.props.subText}</h4>
                     
                </div>
                <div className="linear-gradient"></div>
                
            </div>
        </React.Fragment>
    );}
}

export default CarouselSlide;
